/* eslint-disable no-unused-vars */
export enum AuthConst {
    SIGNUP = 'SIGNUP',
    SIGNUP_SUCCESS = 'SIGNUP_SUCCESS',
    SIGNUP_FAIL = 'SIGNUP_FAIL',

    SIGNIN = 'SIGNIN',
    SIGNIN_SUCCESS = 'SIGNIN_SUCCESS',
    SIGNIN_FAIL = 'SIGNIN_FAIL',

    AUTHTOKEN = 'AUTHTOKEN',
    SETUSERINFO = 'SETUSERINFO',

    GETAUTH = 'GETAUTH',
    SETAUTH = 'SETAUTH'
}

export enum RoleCont {
    ITMTCHAIRMAIN = 1,
    ITMTLEADER = 2,
    ITMTSUBLEADER = 3,
    ITMTMEMBER = 4,
    TSP = 5,
    PRG = 6,
    SecretaryGeneral = 7,
    CommitteeMembers = 8,
    CoOrdinator = 9,
    PLTMTLeader = 10,
    PL_TMT_SUB_LEADER = 11,
    PL_TMT_MEMBER = 12
}
